const wordNav = [
    {"url": "/words", "name": "words"},{"url": "/words/tag", "name": "tags"}, {"url": "/words/index", "name": "index"}, {"url": "/words/about", "name": "about"}, {"url": "/contact", "name": "contact"}];

export {wordNav};